export default __webpack_public_path__ + "static/media/ico_arrow_right_bold.e1d08617.svg";